import { List, Map } from 'immutable';
import { useLocalStorage } from 'core/hooks';

export const useDemoSuccessMeasureResponses = (successMeasureId, lessonId) => {
  const defaultSuccessMeasures = List();

  const isImmutable = true;

  const [storedSuccessMeasureResponses, setStoredSuccessMeasureResponse] =
    useLocalStorage(
      `successMeasureResponses_lessonId-${lessonId}_successMeasureId-${successMeasureId}`,
      defaultSuccessMeasures,
      isImmutable
    );

  function save(
    lessonId,
    profileId,
    successMeasureId,
    value,
    successNavigateUrl
  ) {
    // successNavigateUrl is used in the original useSuccessMeasure hook

    const newResponse = Map({
      id: lessonId,
      profile_id: profileId,
      success_measure_id: successMeasureId,
      value,
    });

    const index = storedSuccessMeasureResponses.findIndex(
      (res) =>
        res.get('success_measure_id') === successMeasureId &&
        res.get('profile_id') === profileId
    );

    const existingResponse = index > -1;

    const updatedSuccessMeasureResponses = existingResponse
      ? storedSuccessMeasureResponses.set(index, newResponse)
      : storedSuccessMeasureResponses.push(newResponse);

    setStoredSuccessMeasureResponse(updatedSuccessMeasureResponses);
  }

  return {
    data: storedSuccessMeasureResponses,
    loading: false,
    save,
  };
};
